import React from "react"
import { currencyFormatWithSign } from "scripts/utils/currencyFormat"
import type { GlobalCartType } from "scripts/types"
import Totals from "../Totals"

type CartTotalProps = {
  globalCart: GlobalCartType
  labels: Record<string, unknown>
  inTotalLabel?: string
  className?: string
}

const CartTotal: React.FC<CartTotalProps> = ({
  globalCart,
  labels,
  inTotalLabel,
  className,
}) => {
  if (!globalCart.discount || !globalCart.discount.totals) {
    return null
  }
  
  const discountTotals = globalCart.discount.totals
  const currencyIcon = globalCart.discount.currency_icon || discountTotals.currency_icon

  return (
    <div className={`checkout-cart__totals totals-box ${className || ""}`}>
      <Totals globalCart={globalCart} labels={labels} />
      <div className="total-price flex-c-b">
        <div className="title body-16-bold">
          {inTotalLabel || (labels as { in_total?: string }).in_total}
        </div>
        <div className="num title-24-bold js_total_price">
          {currencyFormatWithSign(discountTotals.total_sum_with_discount, currencyIcon) ||
            "0 ₴"}
        </div>
      </div>
    </div>
  )
}
export default CartTotal
